import React, { ComponentProps, FC, useCallback, useMemo } from 'react';
import { useFeatureFlags } from '@funtech-int/yango-shared';

import { useBatchedHandlers } from '@/shared/hooks/useBatchedHandlers';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

import { usePlayerContentFinished } from '../../../analytics/hooks/use-player-content-finished';
import { useEpisodeCurrentStream } from '../../../../episode-player/hooks/use-episode-current-stream';

import { EpisodeNavigatorPopupButton } from './component';

interface Props extends ComponentProps<typeof EpisodeNavigatorPopupButton> {
    psid: string;
}

export const EpisodeNavigatorPopupButtonAnalytics: FC<Props> = (props) => {
    const { contentId, onSelectEpisode, psid, filmId } = props;
    const { vsid } = usePlayerInstance() || {};
    const { flags } = useFeatureFlags();

    const isDynamicPrerollEnabled = flags.get('isDynamicPrerollEnabled', 'boolean', false);

    const manifestUrl = useEpisodeCurrentStream(contentId)?.uri;

    const eventMeta = useMemo(
        () => ({
            vsid: vsid ?? '',
            psid: psid ?? '',
            filmId: filmId ?? '',
            contentId: contentId ?? '',
            manifestUrl: manifestUrl ?? '',
        }),
        [vsid, psid, filmId, contentId, manifestUrl]
    );

    const trackPlayerContentFinished = usePlayerContentFinished(eventMeta);
    const trackPlayerContentFinishedWithVsid = useCallback(
        () => trackPlayerContentFinished({ vsid: vsid ?? '', isDynamicPrerollEnabled }),
        [trackPlayerContentFinished, vsid, isDynamicPrerollEnabled]
    );
    const handleSelectEpisode = useBatchedHandlers([
        trackPlayerContentFinishedWithVsid,
        onSelectEpisode,
    ]);

    return <EpisodeNavigatorPopupButton {...props} onSelectEpisode={handleSelectEpisode} />;
};
